import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/base/form/hook-form";
import {
  PhoneInput,
  type PhoneInputProps,
} from "../input/input-phone";

export type FormPhoneFieldProps<
  TFieldValues extends FieldValues = FieldValues,
> = {
  field: ControllerRenderProps<TFieldValues, Path<TFieldValues>>;
  label?: string;
  labelClasses?: string;
  inputClasses?: string;
  description?: string;
  className?: string;
} & PhoneInputProps;

export const FormPhoneField = <
  TFieldValues extends FieldValues = FieldValues,
>({
  label,
  labelClasses,
  description,
  isRequired,
  field,
  className,
  inputClasses,
  ...props
}: FormPhoneFieldProps<TFieldValues>) => {
  return (
    <FormItem className={className}>
      <FormLabel className={labelClasses} required={isRequired}>
        {label}
      </FormLabel>
      <FormControl>
        <PhoneInput
          {...props}
          {...field}
          aria-label={label}
          className={inputClasses}
          isRequired={isRequired}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
};

FormPhoneField.displayName = "FormPhoneField";
